module.controller(
    'techniqueListCtrl',
    [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService', 'ASEBIOL_CONSTANTS', 'analysisService',
        function($scope, $rootScope, $state, regulationService, alertService, ASEBIOL_CONSTANTS, analysisService) {

    		$scope.idRegulation = $state.params.idRegulation;
    		$scope.idAnalysis = $state.params.idAnalysis;
            $scope.techniques = [];
            $scope.varShowHide = false;
            $scope.loading = false;
            $scope.filter = {};
            $scope.pagination = {
                    current : 1,
                    total : 0
                };
            
        	$scope.technique = {
        			MinAmountUnits : {},
        			ResultTypeUnits : {},
        			resulttype : null,
        			presenceAbsenceLimit : false,
        			dilutions: {}
        		};
        	
        	$scope.techniqueSelected=[];
        	$scope.methodSelected=[];
        	$scope.techSelect;
        	$scope.techniqueTypeId;
        	
        	$scope.CNT = ASEBIOL_CONSTANTS;

            /**
             *
             * @param idUser
             */
            $scope.search = function(page) {
                $scope.loading = true;
                
                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;
                

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                regulationService.searchTechnique($scope.idRegulation, $scope.idAnalysis, filter).then(function(response) {
            	
                
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.techniques = result.results;
                    $scope.pagination.total = result.totalRegisters;
                }, function(response) {
                    $scope.loading = false;
                });
               
            };

            $scope.changeTechniqueState = function(idTechnique, state){
            	if(state){
            		regulationService.enableTechnique($scope.idRegulation, $scope.idAnalysis, idTechnique).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Técnica activa nuevamente en el sistema');
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            	else{
            		regulationService.disableTechnique($scope.idRegulation, $scope.idAnalysis, idTechnique).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Técnica inactiva');
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            };
            
            $scope.removeTechniqueInRegulation= function(idRegulation, idAnalysis, idTechnique){
            	var technique = $scope.techniques.find(function(m){ return m.id == idTechnique; })
                alertService.showSwtQuestion('Eliminar Técnica "'+ technique.name +'" de la Nomrativa', function() {
                    $scope.loading = true;

                    regulationService.removeTechniqueInRegulation(idRegulation,idAnalysis,idTechnique).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Técnica eliminada satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };
            
            $scope.clearFilters = function(){
            	$scope.filter = {};
            };
            
            $scope.search(1);
            
            $scope.ShowHide = function(){
                $scope.varShowHide =! $scope.varShowHide;
            }
            
        	$scope.addTechniqueInRegulation = function() {
        		alertService.showSwtQuestion('Añadir Técnica', function() {
        			$scope.loading = true;
        			
        			var tech = $scope.techniqueSelected.selected[0];

        			regulationService.addTechniqueInRegulation($scope.idRegulation, $scope.idAnalysis, tech.id).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Técnica añadida satisfactoriamente');
        				 $scope.search(1);
        				$scope.ShowHide();
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
        	};
        	
        	
        } ]);


